import './ThankYouCallout.scss'

import { Callout } from '@tallink/components-lib'
import * as PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { getMode } from '../../../selectors/selectors'
import useFormatPrice from '../../../utils/formatPrice'

export default function ThankYouCallout({ email, price }) {
  const { t } = useTranslation()
  const formatPrice = useFormatPrice()
  const mode = useSelector(getMode)

  return (
    <Callout
      body={<p dangerouslySetInnerHTML={{ __html: t(`confirmation.thankYouCallout.message.${mode}`, { email }) }} />}
      summary={
        <div className="thank-you-callout-summary">
          <span className="label">{t('confirmation.thankYouCallout.paidTotal')}</span>
          <span className="price"> {formatPrice(price)}</span>
        </div>
      }
      title={t('confirmation.thankYouCallout.title')}
    />
  )
}

ThankYouCallout.propTypes = {
  email: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired
}
